// #554: Rueckfrage, bevor beim Entfernen der Zuweisung ein Termin mit
// Teilnehmern geloescht wird (die Teilnehmer bekaemen eine Absage).
//
// Der Server antwortet dann mit 409 `planningHasAttendees` und speichert
// nichts. apiService.updateTicket fragt ueber ein CustomEvent nach (Muster
// `sessionExpired`), die Komponente TerminAbsageRueckfrage in App.js zeigt den
// Dialog. So deckt EINE Stelle alle Wege ab, die eine Zuweisung entfernen
// (Bearbeiten, Uebergabe, Kontextmenue, Mobilansicht).

export const TERMIN_ABSAGE_EVENT = 'terminAbsageFrage';

export function istTerminRueckfrage(error) {
  return error?.response?.status === 409 && error?.response?.data?.code === 'planningHasAttendees';
}

// Promise<boolean>. Ohne Listener (Dialog nicht gemountet) heisst die Antwort
// nein: Eine Absage an Kunden geht nie ohne sichtbare Rueckfrage raus.
export function frageTerminAbsage(termine) {
  return new Promise((resolve) => {
    const ev = new CustomEvent(TERMIN_ABSAGE_EVENT, { cancelable: true, detail: { termine: termine || [], antworte: resolve } });
    const uebernommen = !window.dispatchEvent(ev);
    if (!uebernommen) resolve(false);
  });
}

// Der Benutzer hat abgebrochen: Die Aufrufer zeigen dafuer keinen Fehler.
export function abbruchFehler() {
  const err = new Error('Zuweisung nicht entfernt: Termin mit Teilnehmern, Rueckfrage abgelehnt');
  err.abgebrochen = true;
  return err;
}
